import React from 'react';
import "./Info.css";




function  Info () {

return (

    <div className="contain1">
       <div className="vision-mission">
       <div className="our-vision">
           <h1 className="head5">OUR VISION</h1>
           <p className="para2">To maintain the high standards of professionalism, honesty and commitment with delivering quality engineered products by serving our prestigious clients.<br/><br/>


             We envision to undertake the engineering business with a clear focus on becoming the leading electrical and mechanical engineering company with highest-level of
             satisfaction in the industry.</p>
       </div> 

        <div>
            <h1 className="head2">OUR MISSION</h1>
            <p className="para3">We are committed and determined to serve and provide engineering solutions to our valued clients, through maintaining high standards of professionalism while
               achieving clients design requirements with on-time high quality product delivery.<br/><br/>


               We add value to the business and the society at large through cost-effective engineering and operationally efficient products with integrity, honesty and hard work.</p>
        </div>
        </div>
    </div>

)
}




export default Info;